module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('table', {
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "17%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "83%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Introduction#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('i', [_vm._v("Philip Hayward")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01"
    }
  }, [_vm._v("Chapter 1")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01"
    }
  }, [_vm._v("The Middle Eastern Mermaid: Between Myth and Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('i', [_vm._v("Manal Shalaby")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Matsya")]), _vm._v(" Fabulism: Hindu mythologies, Mermaids and syncretism in India and Thailand")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('i', [_vm._v("Philip Hayward")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Japan: The Mermaidisation of the "), _c('i', [_vm._v("Ningyo")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('i', [_vm._v("Philip Hayward")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Legend of the Blue Sea")]), _vm._v(": Mermaids in South Korean folklore and popular culture")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('i', [_vm._v("Sarah Keith and Sung-Ae Lee")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From Dugongs to "), _c('i', [_vm._v("Sinetrons")]), _vm._v(": Syncretic Mermaids in Indonesian Culture")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('i', [_vm._v("Philip Hayward")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Changelings, Conformity and Difference: "), _c('i', [_vm._v("Dysebel")]), _vm._v(" and the Sirena in Filipino Popular Culture")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('i', [_vm._v("Philip Hayward")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Millennial "), _c('i', [_vm._v("Měirényú")]), _vm._v(": Mermaids in 21"), _c('sup', [_vm._v("st")]), _vm._v(" Century Chinese Culture")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('i', [_vm._v("Philip Hayward and Pan Wang")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Song of the "), _c('i', [_vm._v("Sirenas")]), _vm._v(": Mermaids in Latin America and the Caribbean")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('i', [_vm._v("Persephone Braham")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Swimming Ashore: Mermaids in Australian public culture")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('i', [_vm._v("Philip Hayward")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mama Wata Remixed: The Mermaid in Contemporary African-American Culture")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('i', [_vm._v("Nettrice R. Gaskins")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shoreline Revels: Perversity, Polyvalence and Exhibitionism at Coney Island’s Mermaid Parade")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('i', [_vm._v("Philip Hayward and Lisa Milner")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chronological catalogue of audiovisual productions featuring mermaids and mermen referenced in the volume")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Index01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f73dfb3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Contents.vue
// module id = 72
// module chunks = 0